import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Notice } from "@/components/Badges";
import { LEGAL_FORMS, NATIONS, SECTORS, TRADING_STAGES, DEV_STAGES } from "@/lib/format";

const OPTIONS = { legal_form: LEGAL_FORMS, nation: NATIONS, sector: SECTORS, trading_stage: TRADING_STAGES, dev_stage: DEV_STAGES,
  public_disclosure: { none: "No disclosure", confidential_only: "Only under NDA", public: "Yes - publicly" } };
const LONG = new Set(["problem", "solution", "novelty", "target_customers", "competitors", "expenditure", "timetable", "contributors", "ownership_arrangements"]);

export default function MissingAssistant({ project, missing, reload }) {
  const [value, setValue] = useState("");
  const q = missing[0];
  const submit = async (e) => {
    e.preventDefault();
    if (!value) return;
    try {
      const url = q.target === "org" ? `/orgs/${project.org_id}` : `/projects/${project.id}`;
      await api.put(url, { [q.field]: value });
      setValue("");
      reload();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  if (!q) return <Notice tone="ok" testid="missing-complete">All core profile and project questions are answered. Continue to the IP plan, funding matches or an application.</Notice>;
  const opts = OPTIONS[q.field];
  const entries = opts ? (Array.isArray(opts) ? opts.map((o) => [o, o]) : Object.entries(opts)) : null;
  return (
    <section className="card p-6" data-testid="missing-assistant">
      <p className="caption">{missing.length} question{missing.length > 1 ? "s" : ""} remaining · {q.target === "org" ? "Business profile (reused everywhere)" : "This project"}</p>
      <form onSubmit={submit} className="mt-4 space-y-4">
        <label htmlFor="missing-answer" className="block font-display text-lg font-semibold text-[#0B192C]" data-testid="missing-question">{q.label}</label>
        {entries ? (
          <select id="missing-answer" data-testid="missing-answer-input" className="input" value={value} onChange={(e) => setValue(e.target.value)}><option value="">Select…</option>{entries.map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select>
        ) : LONG.has(q.field) ? (
          <textarea id="missing-answer" rows={4} data-testid="missing-answer-input" className="input" value={value} onChange={(e) => setValue(e.target.value)} />
        ) : (
          <input id="missing-answer" data-testid="missing-answer-input" className="input" value={value} onChange={(e) => setValue(e.target.value)} />
        )}
        <p className="text-xs text-slate-500">Your answer is saved as a user-confirmed fact. Only state what you can evidence.</p>
        <div className="flex gap-2">
          <button type="submit" data-testid="missing-answer-submit" className="btn-teal btn-sm">Save and next</button>
        </div>
      </form>
    </section>
  );
}
